// Determine the API base URL based on the environment
export const API_BASE_URL =
  process.env.NODE_ENV === "production" ? "/api" :`http://localhost:8000/api`;

// Define the endpoints
export const LOGIN_ENDPOINT = `${API_BASE_URL}/auth/email/`;
export const REFRESH_TOKEN_ENDPOINT = `${API_BASE_URL}/auth/refresh/`;
export const OTP_VERIFICATION_ENDPOINT = `${API_BASE_URL}/auth/email/verify-otp/`;
export const SELECT_TENANT_ENDPOINT = `${API_BASE_URL}/auth/select-tenant/`;
export const REFRESH_PERMISSIONS_ENDPOINT = `${API_BASE_URL}/auth/refresh-permissions/`;

export const CUSTOMERS_ENDPOINT = `${API_BASE_URL}/customers/`;
export const CUSTOMERS_SEARCH_ENDPOINT = `${API_BASE_URL}/customers/search/`;
export const OASIS_CUSTOMERS_EXPORT_ENDPOINT = `${API_BASE_URL}/customers/export/`;
export const CUSTOMERS_CREATE_ENDPOINT = `${API_BASE_URL}/customers/add/`;
export const CUSTOMERS_EDIT_ENDPOINT = `${API_BASE_URL}/customers/edit/`;

export const MAGENTO_ORDERS_ENDPOINT = `${API_BASE_URL}/magento/`;

export const VANS_ENDPOINT = `${API_BASE_URL}/drivers/vans/`;
export const VANS_EDIT_ENDPOINT = `${API_BASE_URL}/drivers/vans/edit/`;
export const VANS_CREATE_ENDPOINT = `${API_BASE_URL}/drivers/vans/add/`;

export const DRIVERS_ENDPOINT = `${API_BASE_URL}/drivers/`;
export const DRIVERS_SEARCH_ENDPOINT = `${API_BASE_URL}/drivers/search/`;
export const DRIVERS_CREATE_ENDPOINT = `${API_BASE_URL}/drivers/add/`;
export const DRIVERS_EDIT_ENDPOINT = `${API_BASE_URL}/drivers/edit/`;

export const USERS_ENDPOINT = `${API_BASE_URL}/users/`;
export const USERS_CREATE_ENDPOINT = `${API_BASE_URL}/users/`;
export const USERS_EDIT_ENDPOINT = `${API_BASE_URL}/users/`;

export const CHAT_CLIENT_HISTORY_ENDPOINT = `${API_BASE_URL}/chat/topics/clients/history/`;
export const CHAT_HISTORY_ENDPOINT = `${API_BASE_URL}/chat/topics/history/`;

export const ZONES_ENDPOINT = `${API_BASE_URL}/zones/`;
export const ZONE_CREATE_ENDPOINT = `${API_BASE_URL}/zones/add/`;
export const ZONE_EDIT_ENDPOINT = `${API_BASE_URL}/zones/edit/`;
export const SUBZONES_ENDPOINT = `${API_BASE_URL}/zones/sub-zones/`;
export const SUBZONE_EDIT_ENDPOINT = `${API_BASE_URL}/zones/sub-zones/edit/`;
export const SUBZONE_CREATE_ENDPOINT = `${API_BASE_URL}/zones/sub-zones/add/`;
export const ORDERS_ENDPOINT = `${API_BASE_URL}/orders/`;
export const ORDERS_STATUS_EDIT_ENDPOINT = `${API_BASE_URL}/orders/edit-status/`;
export const OASIS_ORDERS_EXPORT_ENDPOINT = `${API_BASE_URL}/orders/export/`;

export const DRIVER_ORDER_REPORTS_URL = `${API_BASE_URL}/reports/drivers/`;
export const CUSTOMER_ORDER_REPORTS_URL = `${API_BASE_URL}/reports/customers/`;
export const ZONE_ORDER_REPORTS_URL = `${API_BASE_URL}/reports/zones/`;

export const MONTHLY_PERFORMANCE_REPORTS_URL = `${API_BASE_URL}/reports/orders-monthly-aggregate/`;
export const TIMESLOT_REPORTS_URL = `${API_BASE_URL}/reports/orders-timeslot-aggregate/`;

export const JOBS_ENDPOINT = `${API_BASE_URL}/jobs/`;
export const JOB_EXECUTE_ENDPOINT = `${API_BASE_URL}/jobs/execute-job/`;
export const JOBS_LOG_ENDPOINT = `${API_BASE_URL}/jobs/logs/`;

export const TEMPLATE_ENDPOINT = `${API_BASE_URL}/templates/`;
export const TEMPLATE_CREATE_ENDPOINT = `${API_BASE_URL}/templates/create/`;
export const TEMPLATE_EDIT_ENDPOINT = `${API_BASE_URL}/templates/edit/`;
export const TEMPLATE_DELETE_ENDPOINT = `${API_BASE_URL}/templates/delete/`;
export const TEMPLATE_STATUS_ENDPOINT = `${API_BASE_URL}/templates/status/`;
export const TEMPLATE_NAMES_ENDPOINT = `${API_BASE_URL}/templates/names/`;
export const TEMPLATE_LIBRARY_ENDPOINT = `${API_BASE_URL}/templates/library/`;
export const MEDIA_ASSET_UPLOAD = `${API_BASE_URL}/templates/media-assets/upload/`;
export const MEDIA_ASSET_DELETE = `${API_BASE_URL}/templates/media-assets/delete/`;

export const TEMPLATE_BROADCAST_ENDPOINT = `${API_BASE_URL}/templates/broadcast/`;
export const VALIDATE_WALLET_ENDPOINT = `${API_BASE_URL}/templates/validate-wallet/`;

export const TEMPLATE_APP_CATALOGS = `${API_BASE_URL}/templates/app-catalogs/`;
export const TEMPLATE_CATALOG_PRODUCTS = `${API_BASE_URL}/templates/catalog-products/`;

export const AUDIENCE_GET_ENDPOINT = `${API_BASE_URL}/audience/`;
export const AUDIENCE_COUNT_ENDPOINT = `${API_BASE_URL}/audience/count/`;
export const AUDIENCE_ADD_ENDPOINT = `${API_BASE_URL}/audience/add-audience/`;
export const AUDIENCE_EDIT_ENDPOINT = `${API_BASE_URL}/audience/edit-audience/`;
export const AUDIENCE_UPDATE_ENDPOINT = `${API_BASE_URL}/audience/add-segment/`;
export const AUDIENCE_DELETE_ENDPOINT = `${API_BASE_URL}/audience/delete-audience/`;
export const AUDIENCE_BULK_DELETE_ENDPOINT = `${API_BASE_URL}/audience/delete-audiences/`;
export const AUDIENCE_FILE_UPLOAD_ENDPOINT = `${API_BASE_URL}/audience/upload-audience/`;
export const AUDIENCE_EXPORT_ENDPOINT = `${API_BASE_URL}/audience/export`;
export const TAG_LIST_ENDPOINT = `${API_BASE_URL}/audience/tags/`;
export const TAG_CREATE_ENDPOINT = `${API_BASE_URL}/audience/tags/create/`;
export const TAG_EDIT_ENDPOINT = `${API_BASE_URL}/audience/tags/update/`;
export const TAG_DELETE_ENDPOINT = `${API_BASE_URL}/audience/tags/delete/`;
export const BULK_UPDATE_ENDPOINT = `${API_BASE_URL}/audience/bulk-update/`;
export const AUDIENCE_SEGMENT_LIST_ENDPOINT = `${API_BASE_URL}/audience/audience-segments/`;
export const AUDIENCE_SEGMENT_CREATE_ENDPOINT = `${API_BASE_URL}/audience/audience-segments/create/`;
export const AUDIENCE_SEGMENT_DETAILS_ENDPOINT = `${API_BASE_URL}/audience/audience-segments/`;
export const AUDIENCE_SEGMENT_UPDATE_ENDPOINT = `${API_BASE_URL}/audience/audience-segments/update/`;
export const AUDIENCE_SEGMENT_DELETE_ENDPOINT = `${API_BASE_URL}/audience/audience-segments/delete/`;

export const SEGMENT_AUDIENCE_ENDPOINT = `${API_BASE_URL}/audience/segment-audience/`;

export const SEGMENT_LIST_ENDPOINT = `${API_BASE_URL}/audience/segments/`;
export const SEGMENT_CREATE_ENDPOINT = `${API_BASE_URL}/audience/segments/create/`;
export const SEGMENT_EDIT_ENDPOINT = `${API_BASE_URL}/audience/segments/update/`;
export const FILE_UPLOAD_AUDIENCE_ENDPOINT = `${API_BASE_URL}/audience/upload-audience/`;

export const CAMPAIGN_LIST_ENDPOINT = `${API_BASE_URL}/campaign/`;
export const CAMPAIGN_CANCEL_ENDPOINT = `${API_BASE_URL}/campaign/cancel/`;
// Campaigns (Beta): campaigns with their WhatsApp + RCS broadcasts
export const CAMPAIGN_OVERVIEW_ENDPOINT = `${API_BASE_URL}/campaign/campaigns/`;
export const SINGLE_BROADCASTS_ENDPOINT = `${API_BASE_URL}/campaign/single-broadcasts/`;
export const getCampaignBroadcastsEndpoint = (campaignId) => `${API_BASE_URL}/campaign/${campaignId}/broadcasts/`;
export const FALLBACK_TEMPLATES_ENDPOINT = `${API_BASE_URL}/campaign/fallback-templates/`;

export const WHATSAPP_BILLING_LIST_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/`;
export const DAILY_USAGE_ANALYTICS_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/daily-usage-analytics/`;
export const COUNTRY_REPORT_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/count/`;
export const WHATSAPP_BILLING_LIST_EXPORT_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/export/`;
export const DAILY_USAGE_ANALYTICS_EXPORT_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/daily-usage-analytics/export/`;
export const WHATSAPP_BILLING_CREATE_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/create/`;

export const WHATSAPP_META_CARD_ENDPOINT = `${API_BASE_URL}/app-usage-analytics/meta-rate-card/`;

export const WHATSAPP_MESSAGE_LOG_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/messages/`;
export const WHATSAPP_MESSAGE_LOG_EXPORT_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/messages/export`;
export const LOG_EXPORT_PREVIEW_ENDPOINT = `${API_BASE_URL}/logs/export/preview/`;
export const LOG_EXPORT_ENDPOINT = `${API_BASE_URL}/logs/export/`;
export const LOG_EXPORT_STATUS_ENDPOINT = `${API_BASE_URL}/logs/export/status/`;
export const LOG_EXPORT_HISTORY_ENDPOINT = `${API_BASE_URL}/logs/export/history/`;
export const WHATSAPP_MARKETING_LOG_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/marketing/`;
export const WHATSAPP_MARKETING_LOG_EXPORT_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/marketing/export`;
export const WHATSAPP_MARKETIN_RETRY_BROADCAST_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/retry-failed-messages/`;

export const WHATSAPP_BROADCAST_LOG_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/broadcast-campaigns/`;
export const GET_ENQUEUED_CAMPAIGN_COUNT = `${API_BASE_URL}/logs/whatsapp/get-enqueued-count-by-campaign-id/`;
export const WHATSAPP_SCHEDULED_BROADCAST_LOG_ENDPOINT = `${API_BASE_URL}/logs/whatsapp/broadcast/scheduled/`;
export const REPORT_EXPORT_URL = `${API_BASE_URL}/reports/export-csv/`;
export const GET_SCHEDULED_BROADCAST_DETAILS_BY_ID = `${API_BASE_URL}/logs/whatsapp/campaigns-details/`;
export const GET_TEMPLATE_DATA_BY_TEMPLATE_NAME = `${API_BASE_URL}/templates/get-template-data/`;
export const EDIT_SCHEDULED_BROADCAST = `${API_BASE_URL}/templates/edit-scheduled-broadcast/`;

export const GENERATE_QR_ENDPOINT = `${API_BASE_URL}/url-qrcode/`;
export const GENERATE_QR_GET_NUMBER_ENDPOINT = `${API_BASE_URL}/url-qrcode/get-num-qr`;

export const SETTINGS_DASHBOARD_ENDPOINT = `${API_BASE_URL}/settings-dashboard/`;
export const CREATE_APP_ENDPOINT = `${API_BASE_URL}/settings-dashboard/create-app/`;
export const CHECK_STATUS_ENDPOINT = `${API_BASE_URL}/settings-dashboard/status/`;
export const TENANT_TIMEZONE_ENDPOINT = `${API_BASE_URL}/settings-dashboard/timezone/`;

export const CHAT_START_TOPIC_ENDPOINT = `${API_BASE_URL}/chat/topics/start/`;
export const CHAT_END_TOPIC_ENDPOINT = `${API_BASE_URL}/chat/topics/end/`;

export const VOICE_WEBRTC_CREDENTIALS_ENDPOINT = `${API_BASE_URL}/voice/webrtc-credentials/`;
export const VOICE_CONFIG_ENDPOINT = `${API_BASE_URL}/voice/config/`;
export const VOICE_CALLER_HISTORY_ENDPOINT = (caller) =>
  `${API_BASE_URL}/voice/calls/${caller}/history/`;
export const VOICE_CALL_RECORDING_URL = (callId) =>
  `${API_BASE_URL}/voice/calls/${callId}/recording-url/`;
export const VOICE_CALL_LOGS_ENDPOINT = `${API_BASE_URL}/voice/call-logs/`;
export const VOICE_CALL_LOGS_EXPORT_ENDPOINT = `${API_BASE_URL}/voice/call-logs/export/`;
export const VOICE_CALL_LOGS_TEMPLATES_ENDPOINT = `${API_BASE_URL}/voice/call-logs/templates/`;
export const VOICE_CALL_EVENTS_ENDPOINT = (callId) =>
  `${API_BASE_URL}/voice/calls/${callId}/events/`;

export const PRODUCTS_GET_ENDPOINT = `${API_BASE_URL}/product/`;
export const PRODUCTS_CREATE_ENDPOINT = `${API_BASE_URL}/product/create/`;
export const PRODUCTS_UPDATE_ENDPOINT = `${API_BASE_URL}/product/update/`;

export const ORDERS_LIST_ENDPOINT = `${API_BASE_URL}/orderitem/orders/`;
export const ORDERS_EXPORT_ENDPOINT = `${API_BASE_URL}/orderitem/orders/export/`;
export const ORDER_ITEMS_LIST_ENDPOINT = `${API_BASE_URL}/orderitem/orders/items/`;
export const KALNIRNAY_CUSTOMERS_LIST_ENDPOINT = `${API_BASE_URL}/kalnirnay/customers/`;
export const KALNIRNAY_CUSTOMERS_EXPORT_ENDPOINT = `${API_BASE_URL}/kalnirnay/customers/export/`;

export const SURVEY_RESPONSES_LIST_ENDPOINT = `${API_BASE_URL}/survey-reports/survey-responses/`;
export const SURVEY_RESPONSES_SUMMARY_ENDPOINT = `${API_BASE_URL}/survey-reports/survey-responses/summary/`;
export const SURVEY_RESPONSES_EXPORT_ENDPOINT = `${API_BASE_URL}/survey-reports/survey-responses/export/`;
export const SUBSCRIPTIONS_ENDPOINT = `${API_BASE_URL}/kalnirnay/subscriptions/`;
export const HOROSCOPE_ENDPOINT = `${API_BASE_URL}/kalnirnay/horoscopes/`;
export const HOROSCOPE_CSV_UPLOAD_ENDPOINT = `${API_BASE_URL}/kalnirnay/horoscopes/upload-csv/`;

export const BUYERS_LIST_ENDPOINT = `${API_BASE_URL}/orderitem/buyers/`;
export const BUYERS_EXPORT_ENDPOINT = `${API_BASE_URL}/orderitem/buyers/export/`;

export const DAILY_HOLDING_ENDPOINT = `${API_BASE_URL}/investments/holdings/daily/`;
export const MONTHLY_HOLDING_ENDPOINT = `${API_BASE_URL}/investments/holdings/monthly/`;
export const CAREPMS_CUSTOMERS_LIST_ENDPOINT = `${API_BASE_URL}/clients/clients/`;
export const CAREPMS_UPLOAD_HISTORY_ENDPOINT = `${API_BASE_URL}/history/upload-history/`;

export const FILE_UPLOAD_HISTORY_ENDPOINT = `${API_BASE_URL}/logs/file-upload-history/`;

export const USER_ENGAGEMENT_ENDPOINT = `${API_BASE_URL}/user-engagement/`;
export const USER_ENGAGEMENT_EXPORT_ENDPOINT = `${API_BASE_URL}/user-engagement/export`;

export const LIST_TEMPLATES_ANALYTICS_ENDPOINT = `${API_BASE_URL}/template-analytics`;
export const TEMPLATE_ANALYTICS_EXPORT_ENDPOINT = `${API_BASE_URL}/template-analytics/export`;
export const RCS_TEMPLATE_ANALYTICS_ENDPOINT = `${API_BASE_URL}/template-analytics/rcs`;
export const GET_INSIGHTS_DATA_FROM_GUPSHUP = `${API_BASE_URL}/template-analytics/get-template-analytics`;

export const REACH_FREQUENCY_CAMPAIGNS_ENDPOINT = `${API_BASE_URL}/reports/reach-frequency/campaigns/`;
export const REACH_FREQUENCY_CARDS_ENDPOINT = `${API_BASE_URL}/reports/reach-frequency/cards/`;
export const REACH_FREQUENCY_CHART_ENDPOINT = `${API_BASE_URL}/reports/reach-frequency/chart/`;
export const REACH_FREQUENCY_TABLE_ENDPOINT = `${API_BASE_URL}/reports/reach-frequency/table/`;

export const GENAI_ENHANCE_TEXT_ENDPOINT = `${API_BASE_URL}/enhance-text/`;

export const APPOINTMENTS_ENDPOINT = `${API_BASE_URL}/appointment-management`;

// export const ORDER_ITEM_GET_ENDPOINT = `${API_BASE_URL}/orderitem/`;
// export const ORDER_ITEM_GET_ENDPOINT = `${API_BASE_URL}/orderitem/`;

export const GET_INVOICES_ENDPOINT = `${API_BASE_URL}/invoices/invoices/`;
export const GET_TENANT_DETAILS = `${API_BASE_URL}/invoices/tenant-details/`;

export const GET_WALLET_ENDPOINT = `${API_BASE_URL}/wallet`;

export const GET_WALLET_DETAILS = `${API_BASE_URL}/wallet/wallet/`;
export const GET_WALLET_STATS = `${API_BASE_URL}/wallet/wallet/stats`;
export const GET_WALLET_SUMMARY = `${API_BASE_URL}/wallet/wallet/summary`;
export const GET_WALLET_MONTHLY_SPEND = `${API_BASE_URL}/wallet/wallet/monthly-spend/`;

export const GET_WALLET_TRANSACTIONS = `${API_BASE_URL}/wallet/transactions/`;
export const GET_WALLET_SINGLE_TRANSACTIONS_ = `${API_BASE_URL}/wallet/transactions/<int:pk>/`;

export const GET_WALLET_ADD_FUNDS = `${API_BASE_URL}/wallet/add-funds/`;
export const GET_WALLET_INITIATE_CASHFREE_ENDPOINT = `${API_BASE_URL}/wallet/initiate-cashfree/`;
export const GET_WALLET_VERIFY_CASHFREE_ENDPOINT = `${API_BASE_URL}/wallet/verify-funds/`;

// export const CALENDLY_STANDALONE_DHRUV = `https://calendly.com/shahdhruv101005/30min`;
export const CALENDLY_ENDPOINT = `${API_BASE_URL}/calendly/`;

export const CONVERSATIONS_ENDPOINT = `${API_BASE_URL}/conversations/`;
export const SEND_MESSAGE_ENDPOINT = (conversationId) =>
  `${API_BASE_URL}/conversations/${conversationId}/send-message/`;
export const MESSAGES_ENDPOINT = (conversationId) =>
  `${API_BASE_URL}/conversations/${conversationId}/messages/`;

export const ZOHO_CALLBACK_ENDPOINT = `${API_BASE_URL}/zoho/callback/`;
export const ZOHO_GET_CREDENTIALS_ENDPOINT = `${API_BASE_URL}/zoho/credentials/`;
export const ZOHO_SYNC_LEADS_ENDPOINT = `${API_BASE_URL}/zoho/sync-leads/`;
export const ZOHO_STATUS_ENDPOINT = `${API_BASE_URL}/zoho/status/`;
export const ZOHO_DISCONNECT_ENDPOINT = `${API_BASE_URL}/zoho/disconnect/`;
export const ZOHO_CONFIGURATION_ENDPOINT = `${API_BASE_URL}/zoho/configuration/`;
export const ZOHO_SYNC_PROGRESS_ENDPOINT = `${API_BASE_URL}/zoho/sync-progress/`;

export const WOOCOMMERCE_CONNECT_ENDPOINT = `${API_BASE_URL}/integrations/woocommerce/connect/`;
export const WOOCOMMERCE_STATUS_ENDPOINT = `${API_BASE_URL}/integrations/woocommerce/status/`;
export const WOOCOMMERCE_DISCONNECT_ENDPOINT = `${API_BASE_URL}/integrations/woocommerce/disconnect/`;

export const STRIPE_CONNECT_ENDPOINT = `${API_BASE_URL}/payments/stripe/connect/`;
export const STRIPE_STATUS_ENDPOINT = `${API_BASE_URL}/payments/stripe/status/`;
export const STRIPE_DISCONNECT_ENDPOINT = `${API_BASE_URL}/payments/stripe/disconnect/`;
export const STRIPE_LAST_WEBHOOK_EVENT_ENDPOINT = `${API_BASE_URL}/payments/stripe/last-webhook-event/`;

export const GET_TENANT_SUBCRIPTION = `${API_BASE_URL}/tenants/subscriptions/`;
export const GET_TENANT_PLANS = `${API_BASE_URL}/tenants/plans/`;
export const GET_TENANT_PLANSPRICINGS = `${API_BASE_URL}/tenants/plan-pricings/`;
export const GET_TENANT_ADDONS = `${API_BASE_URL}/tenants/addons/`;
export const GET_TENANT_ADDONSPRICINGS = `${API_BASE_URL}/tenants/addon-pricings/`;
export const GET_TENANT_CHANNEL = `${API_BASE_URL}/tenants/channel/`;

// Dormakaba APIs
export const GET_DASHBOARD_STATS_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/dashboard/stats/`;
export const GET_INSTALLATION_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/installations/`;
export const PUT_INSTALLATION_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/installations/`;
export const GET_SERVICE_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/services/`;
export const PUT_SERVICE_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/services/`;
export const GET_SALES_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/sales/`;
export const PUT_SALES_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/sales/`;
export const GET_SEARCH_TICKETS_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/tickets/`;
export const GET_RECENT_ACTIVITIES_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/dashboard/recent-activity/`;
export const EXPORT_INSTALLATION_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/export/installations/`;
export const EXPORT_SERVICE_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/export/services/`;
export const EXPORT_SALES_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/export/sales/`;
export const GET_INSTALLATION_CHOICES_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/choices/installation/`;
export const GET_SERVICE_CHOICES_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/choices/service/`;
export const GET_SALES_CHOICES_ENDPOINT = `${API_BASE_URL}/dormakaba_dashboard/choices/sales/`;
//kalnirnay APIs
export const GET_PANCHANG_ENDPOINT = `${API_BASE_URL}/kalnirnay/panchang/`;
export const GET_MUHURAT_ENDPOINT = `${API_BASE_URL}/kalnirnay/muhurat/`;
export const GET_FESTIVAL_VRAT_ENDPOINT = `${API_BASE_URL}/kalnirnay/festival-vrat/`;
export const GET_UPLOAD_LOGS_ENDPOINT = `${API_BASE_URL}/kalnirnay/upload-logs/`;
export const GET_KALNIRNAY_DASHBOARD_STATS_ENDPOINT = `${API_BASE_URL}/kalnirnay/dashboard-stats/`;
export const PUT_CHECK_DATA_ENDPOINT = `${API_BASE_URL}/kalnirnay/check-data-exists/`;
export const PUT_UPLOAD_ENDPOINT = `${API_BASE_URL}/kalnirnay/upload/`;

// Drip Marketing
export const DRIP_CAMPAIGN_LIST_ENDPOINT = `${API_BASE_URL}/drip-marketing/`;
export const DRIP_CAMPAIGN_SAVE_DRAFT_ENDPOINT = `${API_BASE_URL}/drip-marketing/save-draft/`;
export const DRIP_CAMPAIGN_PUBLISH_ENDPOINT = `${API_BASE_URL}/drip-marketing/publish/`;
export const DRIP_CAMPAIGN_DETAILS_ENDPOINT = `${API_BASE_URL}/drip-marketing/details/`;
export const DRIP_CAMPAIGN_PAUSE_ENDPOINT = `${API_BASE_URL}/drip-marketing/pause/`;
export const DRIP_CAMPAIGN_RESUME_ENDPOINT = `${API_BASE_URL}/drip-marketing/resume/`;

export const GET_DASHBOARD_WABA_STATUS = `${API_BASE_URL}/dashboard/waba-status/`;
export const GET_DASHBOARD_AUDIENCE_DATA = `${API_BASE_URL}/dashboard/audience-data/`;
export const GET_HOLIDAY_LIST_ENDPOINT = `${API_BASE_URL}/dashboard/holidays-list`;

// Admin Dashboard
export const ADMIN_LOGIN = `${API_BASE_URL}/admin-auth/admin-login/`;
export const GET_ALL_TENANTS_FOR_SUPER_ADMIN_DASHBOARD = `/admin-dashboard/get-all-tenants/`;
export const GET_DASHBOARD_TILES_COUNT = `/admin-dashboard/get-admin-dashboard-tiles-count/`;
export const GET_CAMPAIGN_TABLE_DATA = `/admin-dashboard/get-campaign-table-data/`;
export const GET_ALL_ACTIVE_USER_SESSIONS_PER_TENANT_VIEW = `/admin-dashboard/get-all-active-user-sessions-per-tenant/`;
export const GET_CRON_JOBS_DATA = `/admin-dashboard/get-cron-jobs-data/`;

export const GET_WABA_CONNECTION_STATUS = `${API_BASE_URL}/settings-dashboard/status/`;
export const GET_CHANNEL_STATUS = `${API_BASE_URL}/settings-dashboard/channel-status/`;
export const CREATE_WABA_CONNECTION_STATUS = `${API_BASE_URL}/settings-dashboard/create-app/`;

export const WA_BUSINESS_ACCOUNT_DATA = `${API_BASE_URL}/settings-dashboard/business/`;
export const WA_BUSINESS_ACCOUNT_PROFILE = `${API_BASE_URL}/settings-dashboard/business/profile/`;
export const WA_BUSINESS_ACCOUNT_ABOUT = `${API_BASE_URL}/settings-dashboard/business/about/`;
export const WA_BUSINESS_ACCOUNT_PHOTO = `${API_BASE_URL}/settings-dashboard/business/photo/`;

export const QUIZ_DASHBOARD_ENDPOINT = `${API_BASE_URL}/otm-quiz/customers/dashboard-stats/`;

export const CUSTOMERS_QUIZ_ENDPOINT = `${API_BASE_URL}/otm-quiz/customers/`;

export const QUIZ_ATTEMPTS_ENDPOINT = `${API_BASE_URL}/otm-quiz/quiz-attempts/`;

export const QUIZ_EXPORT_SUMMARY_ENDPOINT = `${API_BASE_URL}/otm-quiz/export/summary/`;
export const QUIZ_EXPORT_ALL_ENDPOINT = `${API_BASE_URL}/otm-quiz/export/all/`;

export const WHITELABELING_BRANDING_ENDPOINT = `${API_BASE_URL}/whitelabeling/branding/`;

export const GET_RCS_BOTS = `${API_BASE_URL}/rcs-bot/bots/`;
export const POST_RCS_BOTS = `${API_BASE_URL}/rcs-bot/bots/create/`;
export const POST_RCS_BOTS_VERIFICATION = `${API_BASE_URL}/rcs-bot/bots/<int:pk>/submit-verification/`;
export const POST_RCS_BOTS_ADD_TESTER = `${API_BASE_URL}/rcs-bot/bots/testers/add/`;
export const RCS_BOT_TEMPLATES = `${API_BASE_URL}/rcs-templates/create/text/`;
export const RCS_BROADCAST_API = `${API_BASE_URL}/rcs-templates/broadcast/`;
export const GET_RCS_TEMPLATES = `${API_BASE_URL}/rcs-templates/list/`;
export const RCS_BROADCAST_TEMPLATE = `${API_BASE_URL}/rcs-templates/broadcast/`;
export const RCS_UPLOAD_IMAGE = `${API_BASE_URL}/rcs-templates/upload-media/`;

export const RCS_BROADCAST_LOG_ENDPOINT = `${API_BASE_URL}/rcs-logs/rcs-broadcast-logs/`;
export const RCS_BROADCAST_LOG_EXPORT_ENDPOINT = `${API_BASE_URL}/rcs-logs/rcs-broadcast-logs/export/`;
export const RCS_CHAT_LOG_ENDPOINT = `${API_BASE_URL}/rcs-logs/rcs-chat-logs/`;
export const RCS_CHAT_LOG_EXPORT_ENDPOINT = `${API_BASE_URL}/rcs-logs/rcs-chat-logs/export/`;

export const RCS_CAMPAIGNS_ENDPOINT = `${API_BASE_URL}/rcs-campaigns/`;
export const GET_RCS_ENQUEUED_CAMPAIGN_COUNT = `${API_BASE_URL}/rcs-campaigns/get-enqueued-count/`;

export const GET_RCS_BRAND = `${API_BASE_URL}/rcs-brands/branding/`;


export const AI_BOT_CONFIG_ENDPOINT = `${API_BASE_URL}/ai-bot/ai-bot-config/`;
export const AI_SCRAPE_WEBSITE_ENDPOINT = `${API_BASE_URL}/ai-bot/train/scrape-website/`;
export const AI_STOP_SCRAPE_WEBSITE_ENDPOINT = `${API_BASE_URL}/ai-bot/train/scrape-website/stop/`;
export const AI_TRAIN_DOCUMENT_ENDPOINT = `${API_BASE_URL}/ai-bot/train/document/`;
export const AI_STOP_TRAIN_DOCUMENT_ENDPOINT = `${API_BASE_URL}/ai-bot/train/document/stop/`;
export const AI_REEMBED_KNOWLEDGE_BASE_ENDPOINT = `${API_BASE_URL}/ai-bot/train/reembed/`;
export const AI_CLEAR_KNOWLEDGE_BASE_ENDPOINT = `${API_BASE_URL}/ai-bot/knowledge-base/clear/`;
export const AI_KNOWLEDGE_BASE_TOPICS_ENDPOINT = `${API_BASE_URL}/ai-bot/knowledge-base/topics/`;

// AI providers (BB-2764): tenant AI keys, AI settings and selectable models
export const AI_PROVIDERS_ENDPOINT = `${API_BASE_URL}/integrations/ai/providers/`;
export const AI_PROVIDER_CONNECT_ENDPOINT = (slug) => `${API_BASE_URL}/integrations/ai/providers/${slug}/connect/`;
export const AI_PROVIDER_VERIFY_ENDPOINT = (slug) => `${API_BASE_URL}/integrations/ai/providers/${slug}/verify/`;
export const AI_PROVIDER_ENDPOINT = (slug) => `${API_BASE_URL}/integrations/ai/providers/${slug}/`;
export const AI_SETTINGS_ENDPOINT = `${API_BASE_URL}/integrations/ai/settings/`;
export const AI_AVAILABLE_MODELS_ENDPOINT = `${API_BASE_URL}/integrations/ai/models/`;

export const AI_REPORT_OVERVIEW = `${API_BASE_URL}/ai-bot/analytics/overview/`;
export const AI_REPORT_TOKEN_USAGE = `${API_BASE_URL}/ai-bot/analytics/token-usage/`;
export const AI_REPORT_USER_BEHAVIOUR = `${API_BASE_URL}/ai-bot/analytics/user-behaviour/`;
export const AI_REPORT_INTENT_ANALYSIS = `${API_BASE_URL}/ai-bot/analytics/intent-analysis/`;
export const AI_REPORT_PERFORMANCE = `${API_BASE_URL}/ai-bot/analytics/performance/`;
export const AI_REPORT_REPORT = `${API_BASE_URL}/ai-bot/analytics/report/`;

export const AI_TOKEN_CALCULATOR_ENDPOINT = `${API_BASE_URL}/ai-bot/token-calculator/`;

export const APPOINTMENT_MANAGEMENT_CHECK_GOOGLE_CALENDAR_SYNC_STATE = `${API_BASE_URL}/appointment-management/google-calendar/sync-state/`;
export const APPOINTMENT_MANAGEMENT_SYNC_GOOGLE_CALENDAR = `${API_BASE_URL}/appointment-management/google-calendar/sync/`;
export const APPOINTMENT_MANAGEMENT_GOOGLE_CALENDAR_MONTH_VIEW = `${API_BASE_URL}/appointment-management/google-calendar/month-view/`;
export const APPOINTMENT_MANAGEMENT_GOOGLE_CALENDAR_APPOINTMENT_CHECK = `${API_BASE_URL}/appointment-management/google-calendar/appointment-check/`;
export const APPOINTMENT_MANAGEMENT_APPOINTMENT_AGENTS = `${API_BASE_URL}/appointment-management/appointments/agents/`;
export const APPOINTMENT_MANAGEMENT_ASSIGN_APPOINTMENT_AGENT = `${API_BASE_URL}/appointment-management/appointments/assign-agent/`;

export const GET_SUBSCRIPTIONS = `${API_BASE_URL}/tenants/subscriptions/`;
export const GET_SUBSCRIPTION_ADDONS_API = `${API_BASE_URL}/subscription/subscription-addons/`;
export const POST_CREATE_SUBSCRIPTION = `${API_BASE_URL}/subscription/create-subscription/`;
export const POST_CALCULATE_CHECKOUT = `${API_BASE_URL}/subscription/calculate-checkout/`;
export const POST_CALCULATE_ADDON_CHECKOUT = `${API_BASE_URL}/subscription/calculate-addon-checkout/`;
export const POST_PURCHASE_ADDONS = `${API_BASE_URL}/subscription/purchase-addons/`;
export const GET_SUBSCRIPTION_CALLBACK = `${API_BASE_URL}/subscription/callback/`;
export const GET_SUBSCRIPTION_INVOICE_SUMMARY = `${API_BASE_URL}/subscription/invoice-summary/`;
export const GET_TRANSACTIONS_LIST = `${API_BASE_URL}/tenants/transactions/`;

export const GET_TAX_RULES = `${API_BASE_URL}/invoices/tax-rule/`;

export const GET_INVOICES_LIST = `${API_BASE_URL}/subscription/list/`;
export const DOWNLOAD_INVOICE_URL = `${API_BASE_URL}/subscription/download/`; // Base part

export const TENANT_INTEGRATIONS = `${API_BASE_URL}/tenants/integrations/`;
export const TENANT_ENABLE_INTEGRATION = `${API_BASE_URL}/tenants/integrations/enable/`;
export const TENANT_DISABLE_INTEGRATION = `${API_BASE_URL}/tenants/integrations/disable/`;

export const NODEBOT_NODE_TYPES = `${API_BASE_URL}/nodebot/node-types/`;
export const NODEBOT_NODEBOTS = `${API_BASE_URL}/nodebot/nodebots/`;
export const NODEBOT_NODEBOTS_BULK_UPDATE = `${API_BASE_URL}/nodebot/nodebots/bulk-update/`;
export const NODEBOT_NODEBOTS_DETAIL = `${API_BASE_URL}/nodebot/nodebots/detail/`;
export const NODEBOT_NODEBOTS_CREATE = `${API_BASE_URL}/nodebot/nodebots/create/`;
export const NODEBOT_NODES_CREATE = `${API_BASE_URL}/nodebot/nodes/create/`;
export const NODEBOT_NODES = `${API_BASE_URL}/nodebot/nodes/`;
export const NODEBOT_EDGES_CREATE = `${API_BASE_URL}/nodebot/edges/create/`;
export const NODEBOT_EDGES = `${API_BASE_URL}/nodebot/edges/`;

export const NODEBOT_BOT_HANDLERS = `${API_BASE_URL}/nodebot/bot-handlers/`;
export const NODEBOT_CUSTOM_CHATBOTS = `${API_BASE_URL}/nodebot/custom-chatbots/`;
export const NODEBOT_CUSTOM_CHATBOTS_CREATE = `${API_BASE_URL}/nodebot/custom-chatbots/create/`;
export const NODEBOT_FALLBACK_AUTORESPONDERS = `${API_BASE_URL}/nodebot/fallback-autoresponders/`;
export const NODEBOT_FALLBACK_AUTORESPONDERS_CREATE = `${API_BASE_URL}/nodebot/fallback-autoresponders/create/`;

export const SIP_REMINDER_TRACKING_ENDPOINT = `${API_BASE_URL}/fintalq/sip-reminders/`;

export const FORMS_FORMS = `${API_BASE_URL}/forms/`;
export const FORMS_FORMS_CREATE = `${API_BASE_URL}/forms/create/`;
export const FORMS_CHECK_NAME = `${API_BASE_URL}/forms/check-name/`;
export const FORMS_STATUS_COUNTS = `${API_BASE_URL}/forms/status-counts/`;
export const FORMS_FORM_DRAFT = (id) => `${API_BASE_URL}/forms/${id}/draft/`;
export const FORMS_FORM_DUPLICATE = (id) => `${API_BASE_URL}/forms/${id}/duplicate/`;
export const FORMS_SUBMISSIONS = (id) => `${API_BASE_URL}/forms/${id}/submissions/`;
export const FORMS_SUBMISSION_COLUMNS = (id) => `${API_BASE_URL}/forms/${id}/submissions/columns/`;
export const FORMS_SUBMISSION_STATS = (id) => `${API_BASE_URL}/forms/${id}/submissions/stats/`;
export const FORMS_SUBMISSION_EXPORT = (id) => `${API_BASE_URL}/forms/${id}/submissions/export/`;
export const FORMS_FORM_BUILDER = (id) => `${API_BASE_URL}/forms/${id}/builder/`;
export const FORMS_FORM_BUILDER_GENERATE = (id) => `${API_BASE_URL}/forms/${id}/builder/generate/`;
export const FORMS_FORM_IMAGES = (id) => `${API_BASE_URL}/forms/${id}/images/`;
export const FORMS_FORM_IMAGE = (id, imageId) => `${API_BASE_URL}/forms/${id}/images/${imageId}/`;
export const FORMS_FORM_TEST_SEND = (id) => `${API_BASE_URL}/forms/${id}/test-send/`;
export const FORMS_FORM_PUBLISH = (id) => `${API_BASE_URL}/forms/${id}/publish/`;
export const FORMS_FORM_PUBLISH_CHECKS = (id) => `${API_BASE_URL}/forms/${id}/publish/checks/`;
export const FORMS_FORM_PUBLISH_STATUS = (id) => `${API_BASE_URL}/forms/${id}/publish/status/`;
export const FORMS_UNMATCHED_REPLIES = `${API_BASE_URL}/forms/unmatched-replies/`;
export const FORMS_DATA_SETTINGS = (id) => `${API_BASE_URL}/forms/${id}/data-settings/`;
export const FORMS_SUBMISSION_DETAIL = (id, submissionId) => `${API_BASE_URL}/forms/${id}/submissions/${submissionId}/`;

export const LEAD_GEN_LEADS = `${API_BASE_URL}/lead-generation/`;
export const LEAD_GEN_CUSTOMERS = `${API_BASE_URL}/lead-generation/customers/`;
export const LEAD_GEN_LEADS_EXPORT_PREVIEW = `${API_BASE_URL}/lead-generation/export/preview/`;
export const LEAD_GEN_LEADS_EXPORT = `${API_BASE_URL}/lead-generation/export/`;
export const LEAD_GEN_CUSTOMERS_EXPORT_PREVIEW = `${API_BASE_URL}/lead-generation/customers/export/preview/`;
export const LEAD_GEN_CUSTOMERS_EXPORT = `${API_BASE_URL}/lead-generation/customers/export/`;
export const FORMS_FORMS_EDIT = `${API_BASE_URL}/forms/edit/`;
export const FORMS_PRESETS = `${API_BASE_URL}/forms/presets/`;
export const FORMS_CATEGORIES_PRESETS = `${API_BASE_URL}/forms/categories-presets/`;
export const FORMS_FORM_DETAIL = (id) => `${API_BASE_URL}/forms/`;
export const FORMS_FORM_EDIT = (id) => `${API_BASE_URL}/forms/edit/${id}/`;
export const FORMS_PRESET_DETAIL = (id) => `${API_BASE_URL}/forms/presets/${id}/`;

export const LIST_CREATE_CLIMATRONICS_CUSTOMERS = `${API_BASE_URL}/climatronics/customers/`;
export const BULK_CREATE_CLIMATRONICS_CUSTOMERS = `${API_BASE_URL}/climatronics/customers/bulk/`;
export const EDIT_CLIMATRONICS_CUSTOMERS = (id) => `${API_BASE_URL}/climatronics/customers/${id}/`;
export const LIST_CREATE_CLIMATRONICS_ORDERS = `${API_BASE_URL}/climatronics/orders/`;
export const EDIT_CLIMATRONICS_ORDERS = (id) => `${API_BASE_URL}/climatronics/orders/${id}/`;

// --- Click To WhatsApp Ads (CTWA) ---
export const CTWA_CONFIG = `${API_BASE_URL}/ctwa/config/`;
export const CTWA_CONNECT_TO_META = `${API_BASE_URL}/ctwa/connect/`;
// --- Instagram Flow (Instagram API with Instagram Login) ---
export const INSTAGRAM_CONNECT_START = `${API_BASE_URL}/instagram/connect/start/`;
export const INSTAGRAM_CONNECT_TOKEN = `${API_BASE_URL}/instagram/connect/token/`;
export const INSTAGRAM_ACCOUNTS = `${API_BASE_URL}/instagram/accounts/`;
export const INSTAGRAM_ACCOUNT_DETAIL = (id) => `${API_BASE_URL}/instagram/accounts/${id}/`;
export const INSTAGRAM_ACCOUNT_TEST = (id) => `${API_BASE_URL}/instagram/accounts/${id}/test/`;
export const INSTAGRAM_ACCOUNT_MEDIA = (id) => `${API_BASE_URL}/instagram/accounts/${id}/media/`;
export const INSTAGRAM_ACCOUNT_ICE_BREAKERS = (id) => `${API_BASE_URL}/instagram/accounts/${id}/ice-breakers/`;
export const INSTAGRAM_RULE_TEST = `${API_BASE_URL}/instagram/rules/test/`;
export const INSTAGRAM_CONVERSATIONS = `${API_BASE_URL}/instagram/conversations/`;
export const INSTAGRAM_CONVERSATION_DETAIL = (id) => `${API_BASE_URL}/instagram/conversations/${id}/`;
export const INSTAGRAM_CONVERSATION_SEND = (id) => `${API_BASE_URL}/instagram/conversations/${id}/messages/`;
export const INSTAGRAM_RULES = `${API_BASE_URL}/instagram/rules/`;
export const INSTAGRAM_RULE_DETAIL = (id) => `${API_BASE_URL}/instagram/rules/${id}/`;
export const INSTAGRAM_ACTIVITY = `${API_BASE_URL}/instagram/activity/`;
export const INSTAGRAM_COMMENTS = `${API_BASE_URL}/instagram/comments/`;
export const INSTAGRAM_COMMENTS_HIDE = `${API_BASE_URL}/instagram/comments/hide/`;
export const INSTAGRAM_COMMENT_REPLY = (id) => `${API_BASE_URL}/instagram/comments/${id}/reply/`;

// Meta Graph Fetching (Live from Meta)
export const EXPORT_CLIMATRONICS_CUSTOMERS = `${API_BASE_URL}/climatronics/customers/export/`;
export const CTWA_GET_FB_PAGES = `${API_BASE_URL}/ctwa/meta/pages/`;
export const CTWA_CREATE_FB_PAGE = `${API_BASE_URL}/ctwa/meta/pages/create/`;
export const CTWA_GET_AD_ACCOUNTS = `${API_BASE_URL}/ctwa/meta/adaccounts/`;

// Local Saving
export const CTWA_SAVE_FB_PAGE = `${API_BASE_URL}/ctwa/save/page/`;
export const CTWA_SAVE_AD_ACCOUNT = `${API_BASE_URL}/ctwa/save/adaccount/`;

// Media & Ads (For your Campaign Create component)
export const CTWA_MEDIA_UPLOAD = `${API_BASE_URL}/ctwa/media/upload/`;
export const CTWA_MEDIA_CAROUSEL = `${API_BASE_URL}/ctwa/media/carousel/`;
export const CTWA_TARGETING_SEARCH = `${API_BASE_URL}/ctwa/targeting/search/`;
export const CTWA_CREATE_CAMPAIGN = `${API_BASE_URL}/ctwa/campaigns/`;
export const CTWA_CREATE_ADSET = `${API_BASE_URL}/ctwa/adsets/`;
export const CTWA_CREATE_CREATIVE = `${API_BASE_URL}/ctwa/creatives/`;
export const CTWA_CREATE_AD = `${API_BASE_URL}/ctwa/ads/`;
export const CTWA_DRAFTS = `${API_BASE_URL}/ctwa/drafts/`;
export const CTWA_DRAFT_DETAIL = (id) => `${API_BASE_URL}/ctwa/drafts/${id}/`;
export const CTWA_LIST_CAMPAIGNS = `${API_BASE_URL}/ctwa/meta/campaigns/`;
export const CTWA_UPDATE_CAMPAIGN_STATUS = (id) => `${API_BASE_URL}/ctwa/meta/campaigns/${id}/status/`;
export const CTWA_CAMPAIGN_DETAIL = (id) => `${API_BASE_URL}/ctwa/meta/campaigns/${id}/detail/`;
export const CTWA_AUDIT_LOGS = `${API_BASE_URL}/ctwa/audit-logs/`;
export const CTWA_WABA_PHONES = `${API_BASE_URL}/ctwa/meta/waba/phone-numbers/`;
export const CTWA_LINK_PHONE_TO_PAGE = `${API_BASE_URL}/ctwa/meta/page/link-phone/`;
export const CTWA_REFRESH_INSTAGRAM = `${API_BASE_URL}/ctwa/meta/instagram/refresh/`;
export const CTWA_CREATIVE_PREVIEW = `${API_BASE_URL}/ctwa/creatives/preview/`;

// Ad set layer (campaign → 1 ad set → 2–5 ads): create flow + Manage screen.
export const CTWA_ACCOUNT_CHECKS = `${API_BASE_URL}/ctwa/account/checks/`;
export const CTWA_PLACEMENTS = `${API_BASE_URL}/ctwa/placements/`;
export const CTWA_ESTIMATE = `${API_BASE_URL}/ctwa/estimate/`; // audience size, conversations/day, retired interests
export const CTWA_PUBLISH_VALIDATE = `${API_BASE_URL}/ctwa/publish/validate/`;
export const CTWA_PUBLISH = `${API_BASE_URL}/ctwa/publish/`;
export const CTWA_MANAGE = (campaignId) => `${API_BASE_URL}/ctwa/manage/${campaignId}/`;
export const CTWA_MANAGE_STATUS = (objectId) => `${API_BASE_URL}/ctwa/manage/objects/${objectId}/status/`;
export const CTWA_MANAGE_ADSET = (adsetId) => `${API_BASE_URL}/ctwa/manage/adsets/${adsetId}/`;
export const CTWA_MANAGE_ADSET_DUPLICATE = (adsetId) => `${API_BASE_URL}/ctwa/manage/adsets/${adsetId}/duplicate/`;
export const CTWA_MANAGE_ADSET_ADS = (adsetId) => `${API_BASE_URL}/ctwa/manage/adsets/${adsetId}/ads/`;
export const CTWA_MANAGE_AD = (adId) => `${API_BASE_URL}/ctwa/manage/ads/${adId}/`;

// Insights
export const CTWA_CAMPAIGN_ANALYTICS = (params) => `${API_BASE_URL}/ctwa/meta/analytics/campaigns/?${params}`

export const GET_KALANJAY_CENTRES = `${API_BASE_URL}/kalanjay/centres/`
export const CREATE_KALANJAY_BATCH = `${API_BASE_URL}/kalanjay/batches/`;
export const UPDATE_KALANJAY_BATCH = (batchId) =>
  `${API_BASE_URL}/kalanjay/batches/${batchId}/`;
export const DELETE_KALANJAY_BATCH = (batchId) =>
  `${API_BASE_URL}/kalanjay/batches/${batchId}/`;
export const GET_KALANJAY_BATCHES = `${API_BASE_URL}/kalanjay/batches/`;
export const GET_KALANJAY_BATCH_STATS = (id) => `${API_BASE_URL}/kalanjay/batch/${id}/stats/`
export const GET_KALANJAY_WAITLIST = `${API_BASE_URL}/kalanjay/waitlist/`;
export const CREATE_KALANJAY_WAITLIST = `${API_BASE_URL}/kalanjay/waitlist/`;
export const UPDATE_KALANJAY_WAITLIST = (id) =>
  `${API_BASE_URL}/kalanjay/waitlist/${id}/`;
export const DELETE_KALANJAY_WAITLIST = (id) =>
  `${API_BASE_URL}/kalanjay/waitlist/${id}/`;
export const CONVERT_KALANJAY_WAITLIST = (id) =>
  `${API_BASE_URL}/kalanjay/waitlist/${id}/convert/`;

export const GET_KALANJAY_STUDENTS = `${API_BASE_URL}/kalanjay/students/`;

export const GET_KALANJAY_BATCH_STUDENTS = (batchId) =>
  `${API_BASE_URL}/kalanjay/batches/${batchId}/students/`;

export const CREATE_KALANJAY_STUDENT = `${API_BASE_URL}/kalanjay/students/`;
export const GET_KALANJAY_STUDENT_DETAIL = (studentId) =>
  `${API_BASE_URL}/kalanjay/students/${studentId}/`;
export const UPDATE_KALANJAY_STUDENT = (studentId) =>
  `${API_BASE_URL}/kalanjay/students/${studentId}/`;

export const DELETE_KALANJAY_STUDENT = (studentId) =>
  `${API_BASE_URL}/kalanjay/students/${studentId}/`;
export const UPDATE_KALANJAY_BATCH_ENROLLMENT = (enrollmentId) =>
  `${API_BASE_URL}/kalanjay/enrollments/${enrollmentId}/`;


export const GET_KALANJAY_EXAMS = `${API_BASE_URL}/kalanjay/exams/`;

export const CREATE_KALANJAY_EXAM = `${API_BASE_URL}/kalanjay/exams/`;

export const UPDATE_KALANJAY_EXAM = (examId) =>
  `${API_BASE_URL}/kalanjay/exams/${examId}/`;

export const DELETE_KALANJAY_EXAM = (examId) =>
  `${API_BASE_URL}/kalanjay/exams/${examId}/`;

export const GET_KALANJAY_FEES = `${API_BASE_URL}/kalanjay/fees/`;

export const CREATE_KALANJAY_FEE = `${API_BASE_URL}/kalanjay/fees/`;

export const UPDATE_KALANJAY_FEE = (feeId) =>
  `${API_BASE_URL}/kalanjay/fees/${feeId}/`;

export const DELETE_KALANJAY_FEE = (feeId) =>
  `${API_BASE_URL}/kalanjay/fees/${feeId}/`;
export const MARK_KALANJAY_FEE_PAID = (feeId) =>
  `${API_BASE_URL}/kalanjay/fees/${feeId}/mark-paid/`;

export const GET_KALANJAY_AGE_GROUPS = `${API_BASE_URL}/kalanjay/age-groups/`;

export const DAILY_USAGE_RCS_ANALYTICS_ENDPOINT = `${API_BASE_URL}/rcs-billing/daily-usage-analytics/`;
export const RCS_RATECARD_ENDPOINT = `${API_BASE_URL}/rcs-billing/rate-cards/`;
export const RCS_RATES_ENDPOINT = `${API_BASE_URL}/rcs-billing/rcs-rates/`;
export const BATCH_WISE_COLLECTION = `${API_BASE_URL}/kalanjay/reports/collection/`

export const GET_TENANT_ONBOARDING_OPTIONS_USER_DETAILS = `${API_BASE_URL}/tenants/onboarding/options/user-details/`;
export const GET_TENANT_ONBOARDING_OPTIONS_COMPANY_DETAILS = `${API_BASE_URL}/tenants/onboarding/options/company-details/`;
export const VALIDATE_PROMO_CODE_ENDPOINT = `${API_BASE_URL}/tenants/onboarding/validate-promo-code/`;

// MFD (Mutual Fund Distributor)
export const MFD_LEADS_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/leads/`;
export const MFD_REGISTERED_LEADS_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/registered-leads/`;
export const MFD_CLIENTS_ENDPOINT     = `${API_BASE_URL}/mutual-fund-distributor/clients/`;
export const MFD_CLIENTS_ALL_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/clients/all/`;
export const MFD_DAILY_HOLDINGS_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/daily-holdings/`;
export const MFD_CLIENT_CSV_UPLOAD_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/clients/upload-csv/`;
export const MFD_DAILY_HOLDING_CSV_UPLOAD_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/daily-holdings/upload-csv/`;
export const MFD_UPLOAD_LOGS_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/upload-logs/`;
export const MFD_REPORT_REQUESTS_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/report-requests/`;
export const MFD_SEND_REPORT_ENDPOINT     = `${API_BASE_URL}/mutual-fund-distributor/send-report/`;
export const MFD_ADVISOR_CALLS_ENDPOINT   = `${API_BASE_URL}/mutual-fund-distributor/advisor-calls/`;
export const MFD_GOAL_PLANS_ENDPOINT      = `${API_BASE_URL}/mutual-fund-distributor/goal-plans/`;
export const MFD_DASHBOARD_ENDPOINT = `${API_BASE_URL}/mutual-fund-distributor/dashboard/`;

export const INSURANCE_HEALTH_ENDPOINT = `${API_BASE_URL}/insurance-reminders/health/`;
export const INSURANCE_HEALTH_UPLOAD_ENDPOINT = `${API_BASE_URL}/insurance-reminders/health/upload-csv/`;
export const INSURANCE_GENERAL_ENDPOINT = `${API_BASE_URL}/insurance-reminders/general/`;
export const INSURANCE_GENERAL_UPLOAD_ENDPOINT = `${API_BASE_URL}/insurance-reminders/general/upload-csv/`;
export const INSURANCE_LIFE_ENDPOINT = `${API_BASE_URL}/insurance-reminders/life/`;
export const INSURANCE_LIFE_UPLOAD_ENDPOINT = `${API_BASE_URL}/insurance-reminders/life/upload-csv/`;
export const INSURANCE_UPLOAD_LOGS_ENDPOINT = `${API_BASE_URL}/insurance-reminders/upload-logs/`;

export const EMI_REMINDERS_ENDPOINT = `${API_BASE_URL}/emi-reminders/`;
export const EMI_REMINDERS_UPLOAD_ENDPOINT = `${API_BASE_URL}/emi-reminders/upload-csv/`;
export const EMI_REMINDERS_UPLOAD_LOGS_ENDPOINT = `${API_BASE_URL}/emi-reminders/upload-logs/`;
export const EMI_REMINDERS_EXPORT_ENDPOINT = `${API_BASE_URL}/emi-reminders/export/`;
export const EMI_REMINDERS_SCHEDULE_ENDPOINT = `${API_BASE_URL}/emi-reminders/schedule/`;

// OTM Pharmacy Upload (master data file uploads + display)
export const PHARMACY_UPLOAD_BATCHES_ENDPOINT = `${API_BASE_URL}/otm-sales/uploads/`;
export const PHARMACY_EMPLOYEES_ENDPOINT = `${API_BASE_URL}/otm-sales/employees/`;
export const PHARMACY_CUSTOMERS_ENDPOINT = `${API_BASE_URL}/otm-sales/customers/`;
export const PHARMACY_CONTACTS_ENDPOINT = `${API_BASE_URL}/otm-sales/pharmacy-contacts/`;
export const PHARMACY_DASHBOARD_STATS_ENDPOINT = `${API_BASE_URL}/otm-sales/dashboard-stats/`;
export const PHARMACY_MASTER_DATA_REPORT_ENDPOINT = `${API_BASE_URL}/otm-sales/master-data-report/`;
export const PHARMACY_PERFORMANCE_REPORT_ENDPOINT = `${API_BASE_URL}/otm-sales/performance-report/`;
export const PHARMACY_PERFORMANCE_REPORT_TREND_ENDPOINT = (employeeId) =>
  `${API_BASE_URL}/otm-sales/performance-report/${employeeId}/trend/`;

export const LIST_CREATE_BOTBRIDGE_LEADS = `${API_BASE_URL}/botbridge/leads/`;
export const EDIT_BOTBRIDGE_LEADS = (id) => `${API_BASE_URL}/botbridge/leads/${id}/`;
//configuration endpoints of Qrcode 
export const SAVE_QR_CONFIGURATION_ENDPOINT = `${API_BASE_URL}/url-qrcode/whatsapp-qr-configurations/create`;

export const GET_QR_CONFIGURATION_ENDPOINT = `${API_BASE_URL}/url-qrcode/whatsapp-qr-configurations`;